import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { folderService } from '../services/folderService';
import type { UpdateFolderDto } from '../types';

interface UpdateFolderVariables {
  id: string;
  data: UpdateFolderDto;
}

export function useUpdateFolder() {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('folders');

  return useMutation({
    mutationFn: ({ id, data }: UpdateFolderVariables) =>
      folderService.updateFolder(id, data),
    onSuccess: (folder) => {
      queryClient.invalidateQueries({ queryKey: ['folders'] });
      queryClient.invalidateQueries({ queryKey: ['folder', folder.id] });
      queryClient.invalidateQueries({ queryKey: ['breadcrumb'] });
      toast.success({ title: t('toasts.updateSuccess') });
    },
    onError: () => {
      toast.danger({ title: t('toasts.updateError') });
    },
  });
}
